(function () {
  let isInitialized = false;

  function isNamePrintFieldset(fs) {
  const legendText = fs?.querySelector('.variant-picker__option-info legend')?.textContent?.trim() ?? '';
  return legendText === '名入れ' || legendText === '名入れ:';
}


  function getCustomilyBox(fromEl) {
    return (
      fromEl.closest('section, form, .product, .product__info-container')?.querySelector('#lc-options') ||
      document.querySelector('#lc-options')
    );
  }

  function getNameInput(fromEl) {
    const sel = 'input[name="properties[名入れ文字]"]';
    return (
      fromEl.closest('section, form, .product, .product__info-container')?.querySelector(sel) ||
      document.querySelector(sel)
    );
  }

  function getSubmitButtons() {
    return document.querySelectorAll(
      'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]'
    );
  }

  function getLabelText(label) {
    return label?.textContent?.trim() || '';
  }

  function isYesText(text) {
  return text === '名入れあり' || text === 'あり' || text.includes('＋名入れ');
}

  function isNoText(text) {
    return text === '名入れなし' || text === 'なし';
  }

  function findNamePrintLabel(fieldset, type) {
    return Array.from(fieldset.querySelectorAll('label.block-swatch')).find(label => {
      const text = getLabelText(label);
      return type === 'yes' ? isYesText(text) : isNoText(text);
    });
  }

  function getInputFromLabel(label) {
    const inputId = label?.getAttribute('for');
    return inputId ? document.getElementById(inputId) : null;
  }

  function getCurrentNamePrintState(fieldset) {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    const checkedLabel = checked ? fieldset.querySelector(`label[for="${checked.id}"]`) : null;
    const text = getLabelText(checkedLabel);

    if (isYesText(text)) return 'yes';
    return 'no';
  }

  function setNamePrintClasses(fieldset, state) {
  const yesLabel = findNamePrintLabel(fieldset, 'yes');

  fieldset.classList.toggle('is-nameprint-yes', state === 'yes');
  fieldset.classList.toggle('is-nameprint-no', state === 'no');

  if (yesLabel) {

    yesLabel.classList.toggle('is-nameprint-yes', state === 'yes');
    yesLabel.classList.toggle('is-nameprint-no', state === 'no');
    yesLabel.classList.toggle('is-selected', state === 'yes');
    yesLabel.classList.toggle('is-unselected', state === 'no');
  }

}



  function selectNamePrintState(fieldset, state) {
    const targetLabel = findNamePrintLabel(fieldset, state);
    const input = getInputFromLabel(targetLabel);

    if (!targetLabel || !input) return;

    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));

    applyState(fieldset, state);
  }
  
function applyState(contextEl, state) {
  const box = getCustomilyBox(contextEl);
  const nameInput = getNameInput(contextEl);
  const fieldset = contextEl.closest?.('fieldset.variant-picker__option') || contextEl;
  const variantPicker = fieldset?.closest?.('.variant-picker');

  if (state === 'no') {
    if (box) box.classList.remove('is-visible');
    if (variantPicker) variantPicker.classList.remove('is-nameprint-open');

    if (nameInput) {
      nameInput.value = '';
      nameInput.dispatchEvent(new Event('input', { bubbles: true }));
      nameInput.dispatchEvent(new Event('change', { bubbles: true }));
      nameInput.blur?.();
    }
  } else {
    if (box) box.classList.add('is-visible');
    if (variantPicker) variantPicker.classList.add('is-nameprint-open');
  }

  if (fieldset && isNamePrintFieldset(fieldset)) {
    setNamePrintClasses(fieldset, state);
  }

  requestAnimationFrame(updateSubmitButtonState);
}
  function isCurrentlyNamePrintNone() {
    const fieldsets = document.querySelectorAll('fieldset.variant-picker__option');

    for (const fieldset of fieldsets) {
      if (!isNamePrintFieldset(fieldset)) continue;
      return getCurrentNamePrintState(fieldset) === 'no';
    }

    return true;
  }

  function validateNamePrintInputs() {
    const isNone = isCurrentlyNamePrintNone();

    if (isNone) {
      return { valid: true };
    }

    const nameInput = getNameInput(document.body);
    const nameValue = nameInput?.value?.trim() || '';

    if (nameValue.length === 0) {
      return {
        valid: false,
        message: '名入れ文字を入力してください',
        focusElement: nameInput
      };
    }

    return { valid: true };
  }

  function updateSubmitButtonState() {
    const validation = validateNamePrintInputs();
    const buttons = getSubmitButtons();

    buttons.forEach(button => {
      if (validation.valid) {
        button.removeAttribute('aria-disabled');
        button.style.opacity = '';
        button.style.cursor = '';
        button.style.pointerEvents = '';
      } else {
        button.setAttribute('aria-disabled', 'true');
        button.style.opacity = '0.5';
        button.style.cursor = 'not-allowed';
      }
    });
  }

  function updateCustomilyVisibility() {
    document.querySelectorAll('fieldset.variant-picker__option').forEach(fieldset => {
      if (!isNamePrintFieldset(fieldset)) return;


      const state = getCurrentNamePrintState(fieldset);
      applyState(fieldset, state);
    });
  }

  function handleClick(e) {
    const label = e.target.closest('label.block-swatch');

    if (!label) return;

    const fieldset = label.closest('fieldset.variant-picker__option');

    if (!fieldset || !isNamePrintFieldset(fieldset)) return;

    const text = getLabelText(label);

    if (!isYesText(text)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const currentState = getCurrentNamePrintState(fieldset);
    const nextState = currentState === 'yes' ? 'no' : 'yes';

    selectNamePrintState(fieldset, nextState);
  }

  function handleButtonClick(e) {
    const button = e.target.closest('button[type="submit"], input[type="submit"]');

    if (!button) return;

    const form = button.closest('form[action*="/cart/add"]');

    if (!form) return;

    const validation = validateNamePrintInputs();

    if (!validation.valid) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      alert(validation.message);
      validation.focusElement?.focus();

      return false;
    }
  }

  function handleFormSubmit(e) {
    const form = e.target;

    if (!form.matches('form[action*="/cart/add"]')) return;

    const validation = validateNamePrintInputs();

    if (!validation.valid) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      alert(validation.message);
      validation.focusElement?.focus();

      return false;
    }
  }

  function handleInputChange() {
    updateSubmitButtonState();
  }

  let observer = null;
  let stickyPriceInitialized = false;
  let quantityLinkedPriceInitialized = false;
  let purchaseOptionRestoreActive = false;
  let purchaseOptionRestoreTimeout = null;

  function formatStickyMoney(cents) {
    const format = window.themeVariables?.settings?.currencyCodeEnabled
      ? window.themeVariables?.settings?.moneyWithCurrencyFormat
      : window.themeVariables?.settings?.moneyFormat;

    if (!format) return '';

    const value = Number.isFinite(cents) ? Math.round(cents) : 0;
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatWithDelimiters = (amount, precision = 2, thousands = ',', decimal = '.') => {
      const number = (amount / 100).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    };

    return format.replace(placeholderRegex, (_match, placeholder) => {
      switch (placeholder) {
        case 'amount':
          return formatWithDelimiters(value);
        case 'amount_no_decimals':
          return formatWithDelimiters(value, 0);
        case 'amount_with_comma_separator':
          return formatWithDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return formatWithDelimiters(value, 0, '.', ',');
        default:
          return formatWithDelimiters(value);
      }
    });
  }

  function getQuantityForForm(formId) {
    if (!formId) return 1;

    const quantityInput = Array.from(document.querySelectorAll('input[name="quantity"]')).find(input => {
      return input.form?.id === formId || input.getAttribute('form') === formId;
    });
    const quantity = parseInt(quantityInput?.value, 10);

    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getQuantityForStickyBar(stickyBar) {
    return getQuantityForForm(stickyBar.getAttribute('form'));
  }

  function normalizeFormId(formIdOrElement) {
    if (typeof formIdOrElement === 'string') return formIdOrElement;
    if (formIdOrElement instanceof HTMLFormElement) return formIdOrElement.id || null;
    if (formIdOrElement instanceof Element) {
      return formIdOrElement.form?.id || formIdOrElement.getAttribute('form') || formIdOrElement.closest('form')?.id || null;
    }

    return null;
  }

  function resetProductQuantitySelector(formId) {
    const normalizedFormId = normalizeFormId(formId);

    document.querySelectorAll('quantity-selector').forEach(selector => {
      const input = selector.querySelector('input[name="quantity"]');

      if (!input) return;

      const inputFormId = input.form?.id || input.getAttribute('form');

      if (normalizedFormId && inputFormId !== normalizedFormId) return;

      const min = parseInt(input.min, 10);
      const max = parseInt(input.max, 10);
      const defaultQuantity = parseInt(input.defaultValue || input.getAttribute('value'), 10);
      let quantity = Number.isFinite(defaultQuantity) ? defaultQuantity : (Number.isFinite(min) ? min : 1);

      if (Number.isFinite(min) && quantity < min) {
        quantity = min;
      }

      if (Number.isFinite(max) && quantity > max) {
        quantity = max;
      }

      if ('quantity' in selector) {
        selector.quantity = String(quantity);
      } else {
        input.value = String(quantity);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      input.closest('quantity-input')?.style.setProperty('--quantity-selector-character-count', `${input.value.length}ch`);
    });
  }

  function getScopedProductRoot(element) {
    return element?.closest?.('.product, product-rerender, safe-sticky, .product-info') || document;
  }

  function getSelectedSellingPlanId(root) {
    const goSubGroupInput = root.querySelector?.('[data-gosub-selling-plan-group-input]');

    if (goSubGroupInput) return getSelectedGoSubSellingPlanId(root);

    const formSellingPlan = root.querySelector?.('input[name="selling_plan"]:checked, input[type="hidden"][name="selling_plan"]');

    if (formSellingPlan?.value) return String(formSellingPlan.value);

    return null;
  }

  function getSelectedGoSubSellingPlanId(root) {
    const checkedGroup = root.querySelector?.('[data-gosub-selling-plan-group-input]:checked');

    if (!checkedGroup || checkedGroup.matches('[data-gosub-purchase-option-one-time]') || checkedGroup.value === 'once') {
      return null;
    }

    const groupId = String(checkedGroup.value);
    const plansContainer = Array.from(root.querySelectorAll?.('[data-gosub-selling-plans-container]') || []).find(element => {
      return String(element.dataset.gosubSellingPlanGroupId) === groupId;
    });
    const planRoot = plansContainer || root;
    const checkedPlan = planRoot.querySelector?.('[data-gosub-selling-plan-input]:checked');

    if (checkedPlan?.value) return String(checkedPlan.value);

    const activePlan = planRoot.querySelector?.('[data-gosub-selling-plan] .active input[data-gosub-selling-plan-input]');

    return activePlan?.value ? String(activePlan.value) : null;
  }

  function syncGoSubSellingPlanToForm(form) {
    if (!form?.matches?.('form[action*="/cart/add"]') || !form.closest('product-form')) return;

    const root = form.closest('.product, product-rerender, safe-sticky, .product-info') || document;
    const goSubWidget = root.querySelector?.('.gosub-product, [data-gosub-selling-plan], [data-gosub-selling-plan-input]');

    if (!goSubWidget) return;

    const sellingPlanId = getSelectedGoSubSellingPlanId(root);
    let syncedInput = form.querySelector('input[data-lc-gosub-selling-plan-sync]');

    if (!sellingPlanId) {
      syncedInput?.remove();
      return;
    }

    const hasAssociatedSellingPlan = Array.from(form.elements).some(element => {
      return element !== syncedInput && element.name === 'selling_plan' && String(element.value) === sellingPlanId;
    });

    if (hasAssociatedSellingPlan) {
      syncedInput?.remove();
      return;
    }

    if (!syncedInput) {
      syncedInput = document.createElement('input');
      syncedInput.type = 'hidden';
      syncedInput.name = 'selling_plan';
      syncedInput.dataset.lcGosubSellingPlanSync = '';
      form.appendChild(syncedInput);
    }

    syncedInput.value = sellingPlanId;
  }

  function syncAllGoSubSellingPlans() {
    document.querySelectorAll('product-form form[action*="/cart/add"]').forEach(syncGoSubSellingPlanToForm);
  }

  function initializeGoSubSellingPlanSync() {
    let syncScheduled = false;

    const scheduleSync = () => {
      if (syncScheduled) return;

      syncScheduled = true;
      window.requestAnimationFrame(() => {
        syncScheduled = false;
        syncAllGoSubSellingPlans();
      });
    };

    document.addEventListener('change', event => {
      if (event.target.closest?.('[class*="gosub"], [id*="gosub"], [data-gosub-selling-plan]')) {
        scheduleSync();
      }
    }, true);

    document.addEventListener('submit', event => {
      syncGoSubSellingPlanToForm(event.target);
    }, true);

    const goSubObserver = new MutationObserver(scheduleSync);

    goSubObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    syncAllGoSubSellingPlans();
    window.setTimeout(syncAllGoSubSellingPlans, 100);
    window.setTimeout(syncAllGoSubSellingPlans, 500);
  }

  function getSelectedVariantId(root, formId) {
    const form = formId ? document.getElementById(formId) : null;
    const variantInput = form?.querySelector?.('input[name="id"], select[name="id"]') || root.querySelector?.('input[name="id"], select[name="id"]');
    const variantId = parseInt(variantInput?.value, 10);

    return Number.isFinite(variantId) ? variantId : null;
  }

  function getPurchaseOptionStorageKey(purchaseOptions) {
    const root = getScopedProductRoot(purchaseOptions);
    const formId = purchaseOptions.querySelector('input[name="selling_plan"]')?.getAttribute('form');
    const variantId = getSelectedVariantId(root, formId);

    return variantId ? `lc-purchase-option:${window.location.pathname}:${variantId}` : null;
  }

  function savePurchaseOptionSelections() {
    document.querySelectorAll('[data-lc-purchase-options]').forEach(purchaseOptions => {
      const storageKey = getPurchaseOptionStorageKey(purchaseOptions);
      const selectedOption = purchaseOptions.querySelector('input[name="selling_plan"]:checked');

      if (!storageKey || !selectedOption) return;

      try {
        window.sessionStorage.setItem(storageKey, selectedOption.value);
      } catch (error) {
        return;
      }
    });
  }

  function syncCyclePlanSelect(select, dispatchChange = false) {
    const purchaseOption = select?.closest?.('.lc-purchase-option');
    const sellingPlanInput = purchaseOption?.querySelector('[data-lc-cycle-plan-radio]');
    const selectedOption = select?.selectedOptions?.[0];

    if (!sellingPlanInput || !selectedOption) return;

    sellingPlanInput.value = selectedOption.value;
    sellingPlanInput.checked = true;

    const visiblePrice = purchaseOption.querySelector('.lc-purchase-option__price [data-lc-selling-plan-price]');
    const selectedPrice = selectedOption.dataset.lcCyclePlanPrice;

    if (visiblePrice && selectedPrice) {
      visiblePrice.dataset.sellingPlanId = selectedOption.value;
      visiblePrice.dataset.lcSubscriptionUnitPrice = selectedPrice;
      visiblePrice.textContent = selectedOption.dataset.lcCyclePlanPriceText || visiblePrice.textContent;
    }

    if (dispatchChange) sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function restorePurchaseOptionSelections() {
    document.querySelectorAll('[data-lc-purchase-options]').forEach(purchaseOptions => {
      const storageKey = getPurchaseOptionStorageKey(purchaseOptions);

      if (!storageKey) return;

      let savedValue;

      try {
        savedValue = window.sessionStorage.getItem(storageKey);
      } catch (error) {
        return;
      }

      if (savedValue === null) return;

      const savedCycleOption = Array.from(purchaseOptions.querySelectorAll('[data-lc-cycle-plan-select] option')).find(option => {
        return option.value === savedValue;
      });

      if (savedCycleOption) {
        const cycleSelect = savedCycleOption.closest('select');
        cycleSelect.value = savedValue;
        syncCyclePlanSelect(cycleSelect);
      }

      const savedOption = Array.from(purchaseOptions.querySelectorAll('input[name="selling_plan"]')).find(option => {
        return option.value === savedValue;
      });

      if (savedOption) savedOption.checked = true;
    });
  }

  function beginPurchaseOptionHistoryRestore(event) {
    const navigationEntry = window.performance.getEntriesByType?.('navigation')?.[0];
    const isHistoryRestore = event?.persisted || navigationEntry?.type === 'back_forward';

    if (!isHistoryRestore) return false;

    purchaseOptionRestoreActive = true;
    window.clearTimeout(purchaseOptionRestoreTimeout);
    purchaseOptionRestoreTimeout = window.setTimeout(() => {
      purchaseOptionRestoreActive = false;
    }, 1000);

    document.querySelectorAll('product-sticky-bar[data-lc-sticky-price]').forEach(stickyBar => {
      stickyBar.setAttribute('data-lc-sticky-price-pending', '');
    });
    document.querySelectorAll('[data-lc-product-price]').forEach(priceItem => {
      priceItem.setAttribute('data-lc-product-price-pending', '');
    });

    restorePurchaseOptionSelections();

    return true;
  }

  function getGoSubProductData(root) {
    const dataElement = root.querySelector?.('[data-gosub-product-json]') || document.querySelector('[data-gosub-product-json]');

    if (!dataElement) return null;

    try {
      return JSON.parse(dataElement.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedGoSubAllocation(root, formId) {
    const sellingPlanId = getSelectedSellingPlanId(root);

    if (!sellingPlanId) return null;

    const productData = getGoSubProductData(root);
    const variantId = getSelectedVariantId(root, formId);
    const variant = productData?.variants?.find(item => Number(item.id) === variantId);
    const allocation = variant?.selling_plan_allocations?.find(item => String(item.selling_plan_id) === sellingPlanId);

    return Number.isFinite(Number(allocation?.price)) ? allocation : null;
  }

  function parseDisplayedMoneyToCents(text) {
    const normalizedText = text?.trim() || '';

    if (!normalizedText) return null;

    const numericText = normalizedText.replace(/[^\d.,]/g, '');

    if (!numericText) return null;

    const hasDecimalCents = /[.,]\d{2}$/.test(numericText);
    const normalizedNumber = hasDecimalCents
      ? `${numericText.slice(0, -3).replace(/[^\d]/g, '')}.${numericText.slice(-2)}`
      : numericText.replace(/[^\d]/g, '');
    const amount = parseFloat(normalizedNumber);

    if (!Number.isFinite(amount)) return null;

    return hasDecimalCents ? Math.round(amount * 100) : amount * 100;
  }

  function getVisibleGoSubPrice() {
    const selectedSellingPlanId = getSelectedSellingPlanId(document);

    if (!selectedSellingPlanId) return null;

    const purchaseOptionPrice = document.querySelector(
      `[data-lc-selling-plan-price][data-selling-plan-id="${CSS.escape(selectedSellingPlanId)}"]`
    );
    const purchaseOptionUnitPrice = parseFloat(purchaseOptionPrice?.dataset.lcSubscriptionUnitPrice);

    if (Number.isFinite(purchaseOptionUnitPrice)) return purchaseOptionUnitPrice;

    const priceElement = Array.from(document.querySelectorAll('.gosub-new-price-banner')).find(element => {
      const style = window.getComputedStyle(element);

      return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    });
    const unitPrice = parseFloat(priceElement?.dataset.lcGosubUnitPrice);

    if (Number.isFinite(unitPrice)) return unitPrice;

    return parseDisplayedMoneyToCents(priceElement?.textContent);
  }

  function updatePurchaseOptionProductPrices() {
    if (purchaseOptionRestoreActive) restorePurchaseOptionSelections();

    document.querySelectorAll('[data-lc-purchase-options]').forEach(purchaseOptions => {
      const selectedPlan = purchaseOptions.querySelector('input[name="selling_plan"]:checked:not([value=""])');
      const nextDiscount = purchaseOptions.querySelector('[data-lc-next-discount-percentage]:not(input)');

      if (selectedPlan && nextDiscount) {
        nextDiscount.textContent = selectedPlan.dataset.lcNextDiscountPercentage || '0';
      }
    });

    document.querySelectorAll('[data-lc-product-price]').forEach(priceItem => {
      const root = getScopedProductRoot(priceItem);
      const sellingPlanId = getSelectedSellingPlanId(root);
      const salePrice = priceItem.querySelector('sale-price');

      if (!salePrice) {
        priceItem.removeAttribute('data-lc-product-price-pending');
        return;
      }

      if (!priceItem.dataset.lcOriginalPriceHtml) {
        priceItem.dataset.lcOriginalPriceHtml = salePrice.innerHTML;
        priceItem.dataset.lcOriginalPriceClass = salePrice.className;
      }

      const planPrice = sellingPlanId
        ? root.querySelector(`[data-lc-selling-plan-price][data-selling-plan-id="${CSS.escape(sellingPlanId)}"]`)
        : null;
      const subscriptionUnitPrice = parseFloat(planPrice?.dataset.lcSubscriptionUnitPrice);

      if (Number.isFinite(subscriptionUnitPrice)) {
        const srOnly = salePrice.querySelector('.sr-only')?.outerHTML || '';
        salePrice.innerHTML = `${srOnly}${formatStickyMoney(subscriptionUnitPrice)}`;
        salePrice.classList.remove('lp-t-h4', 'text-subdued');
        salePrice.classList.add('lp-t-h3', 'text-on-sale');
      } else {
        const purchaseOptions = root.querySelector('[data-lc-purchase-options]');
        const purchaseOptionOneTimePrice = purchaseOptions?.querySelector('[data-lc-one-time-unit-price]');
        const oneTimeUnitPrice = parseFloat(
          purchaseOptionOneTimePrice?.dataset.lcOneTimeUnitPrice || priceItem.dataset.lcOneTimeUnitPrice
        );

        if (Number.isFinite(oneTimeUnitPrice)) {
          const srOnly = salePrice.querySelector('.sr-only')?.outerHTML || '';
          const baseOneTimeUnitPrice = parseFloat(
            priceItem.dataset.lcBaseOneTimeUnitPrice || priceItem.dataset.lcOneTimeUnitPrice
          );
          salePrice.innerHTML = `${srOnly}${formatStickyMoney(oneTimeUnitPrice)}`;

          if (Number.isFinite(baseOneTimeUnitPrice) && oneTimeUnitPrice < baseOneTimeUnitPrice) {
            salePrice.classList.remove('lp-t-h4', 'text-subdued');
            salePrice.classList.add('lp-t-h3', 'text-on-sale');
          } else {
            salePrice.classList.remove('lp-t-h3', 'text-on-sale');
            salePrice.classList.add('text-subdued');
          }
        } else {
          salePrice.innerHTML = priceItem.dataset.lcOriginalPriceHtml;
          salePrice.className = priceItem.dataset.lcOriginalPriceClass;
        }
      }

      priceItem.removeAttribute('data-lc-product-price-pending');
    });
  }

  function updateQuantityLinkedProductPrices() {
    document.querySelectorAll('[data-lc-quantity-price-form]').forEach(priceItem => {
      if (updateGoSubQuantityPrice(priceItem)) return;
      if (Number.isFinite(getVisibleGoSubPrice())) return;

      const salePrice = priceItem.querySelector('sale-price');

      if (!salePrice) return;

      if (!priceItem.dataset.lcQuantityUnitPrice) {
        const unitPrice = parseDisplayedMoneyToCents(salePrice.textContent);

        if (Number.isFinite(unitPrice)) {
          priceItem.dataset.lcQuantityUnitPrice = unitPrice;
        }
      }

      const unitPrice = parseFloat(priceItem.dataset.lcQuantityUnitPrice);

      if (!Number.isFinite(unitPrice)) return;

      const quantity = getQuantityForForm(priceItem.dataset.lcQuantityPriceForm);
      const srOnly = salePrice.querySelector('.sr-only')?.outerHTML || '';
      const nextSalePrice = `${srOnly}${formatStickyMoney(unitPrice * quantity)}`;

      if (salePrice.innerHTML !== nextSalePrice) {
        salePrice.innerHTML = nextSalePrice;
      }

      const compareAtPrice = priceItem.querySelector('compare-at-price');

      if (!compareAtPrice) return;

      if (!priceItem.dataset.lcQuantityCompareAtPrice) {
        const compareAtUnitPrice = parseDisplayedMoneyToCents(compareAtPrice.textContent);

        if (Number.isFinite(compareAtUnitPrice)) {
          priceItem.dataset.lcQuantityCompareAtPrice = compareAtUnitPrice;
        }
      }

      const compareAtUnitPrice = parseFloat(priceItem.dataset.lcQuantityCompareAtPrice);

      if (Number.isFinite(compareAtUnitPrice) && compareAtUnitPrice > unitPrice) {
        const compareSrOnly = compareAtPrice.querySelector('.sr-only')?.outerHTML || '';
        const nextCompareAtPrice = `${compareSrOnly}${formatStickyMoney(compareAtUnitPrice * quantity)}`;

        if (compareAtPrice.innerHTML !== nextCompareAtPrice) {
          compareAtPrice.innerHTML = nextCompareAtPrice;
        }

        compareAtPrice.hidden = false;
      } else {
        compareAtPrice.hidden = true;
      }
    });
  }

  function updateGoSubQuantityPrice(priceItem) {
    const root = getScopedProductRoot(priceItem);
    const formId = priceItem.dataset.lcQuantityPriceForm;
    const allocation = getSelectedGoSubAllocation(root, formId);
    const unitPrice = Number(allocation?.price);
    const compareAtUnitPrice = Number(allocation?.compare_at_price);
    const priceBanner = priceItem.querySelector('.gosub-new-price-banner');

    if (!priceBanner || !Number.isFinite(unitPrice)) return false;

    const quantity = getQuantityForForm(formId);
    const nextPrice = formatStickyMoney(unitPrice * quantity);

    priceBanner.dataset.lcGosubUnitPrice = String(unitPrice);

    if (priceBanner.textContent.trim() !== nextPrice) {
      priceBanner.textContent = nextPrice;
    }

    const compareAtPrice = priceItem.querySelector('sale-price > s');

    if (compareAtPrice && Number.isFinite(compareAtUnitPrice) && compareAtUnitPrice > unitPrice) {
      const nextCompareAtPrice = formatStickyMoney(compareAtUnitPrice * quantity);

      if (compareAtPrice.textContent.trim() !== nextCompareAtPrice) {
        compareAtPrice.textContent = nextCompareAtPrice;
      }

      compareAtPrice.hidden = false;
    }

    return true;
  }

  function initializeQuantityLinkedProductPrices() {
    if (quantityLinkedPriceInitialized) return;

    quantityLinkedPriceInitialized = true;

    document.addEventListener('input', event => {
      if (event.target.matches('input[name="quantity"]')) {
        updateQuantityLinkedProductPrices();
      }
    }, true);

    document.addEventListener('change', event => {
      if (event.target.matches('[data-lc-cycle-plan-select]')) {
        syncCyclePlanSelect(event.target, true);
        return;
      }

      if (event.target.matches('input[name="quantity"], input[name="id"], input[name="selling_plan"], [data-gosub-selling-plan-input], [data-gosub-selling-plan-group-input]')) {
        if (event.target.matches('[data-lc-purchase-options] input[name="selling_plan"]')) {
          savePurchaseOptionSelections();
        }

        window.setTimeout(updatePurchaseOptionProductPrices, 0);
        window.setTimeout(updateQuantityLinkedProductPrices, 0);
        window.setTimeout(updateQuantityLinkedProductPrices, 100);
      }
    }, true);

    document.addEventListener('variant:change', event => {
      window.setTimeout(() => {
        resetProductQuantitySelector(event.detail?.formId);
        updatePurchaseOptionProductPrices();
        updateQuantityLinkedProductPrices();
      }, 0);
    }, true);

    const productPriceMountObserver = new MutationObserver(mutations => {
      const shouldUpdate = mutations.some(mutation => {
        return Array.from(mutation.addedNodes).some(node => {
          return node.nodeType === Node.ELEMENT_NODE && (
            node.matches?.('[data-lc-quantity-price-form]') ||
            node.querySelector?.('[data-lc-quantity-price-form]') ||
            node.matches?.('[data-lc-product-price]') ||
            node.querySelector?.('[data-lc-product-price]')
          );
        });
      });

      if (shouldUpdate) {
        window.requestAnimationFrame(() => {
          updatePurchaseOptionProductPrices();
          updateQuantityLinkedProductPrices();
        });
      }
    });

    productPriceMountObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    updatePurchaseOptionProductPrices();
    updateQuantityLinkedProductPrices();
  }

  function updateStickyBarPrices() {
    document.querySelectorAll('product-sticky-bar[data-lc-sticky-price]').forEach(stickyBar => {
      const basePrice = parseFloat(stickyBar.dataset.lcStickyPrice);

      if (!Number.isFinite(basePrice)) {
        stickyBar.removeAttribute('data-lc-sticky-price-pending');
        return;
      }

      const quantity = getQuantityForStickyBar(stickyBar);
      const goSubPrice = getVisibleGoSubPrice();
      const unitPrice = Number.isFinite(goSubPrice) ? goSubPrice : basePrice;
      const totalPrice = unitPrice * quantity;
      const salePrice = stickyBar.querySelector('sale-price');

      if (salePrice) {
        const srOnly = salePrice.querySelector('.sr-only')?.outerHTML || '';
        const formattedTotalPrice = formatStickyMoney(totalPrice);
        const displayedPrice = quantity > 1
          ? `<span class="lc-sticky-price-calculation"><span class="lc-sticky-price-calculation__number">${formatStickyMoney(unitPrice)}</span><span class="lc-sticky-price-calculation__operator">×</span><span class="lc-sticky-price-calculation__number">${quantity}</span><span class="lc-sticky-price-calculation__operator">=</span><span class="lc-sticky-price-calculation__number">${formattedTotalPrice}</span></span>`
          : formattedTotalPrice;
        const nextSalePrice = `${srOnly}${displayedPrice}`;

        if (salePrice.innerHTML !== nextSalePrice) {
          salePrice.innerHTML = nextSalePrice;
        }
      }

      const baseCompareAtPrice = parseFloat(stickyBar.dataset.lcStickyCompareAtPrice);
      const compareAtPrice = stickyBar.querySelector('compare-at-price');

      if (!compareAtPrice) {
        stickyBar.removeAttribute('data-lc-sticky-price-pending');
        return;
      }

      if (Number.isFinite(baseCompareAtPrice) && baseCompareAtPrice > unitPrice) {
        const srOnly = compareAtPrice.querySelector('.sr-only')?.outerHTML || '';
        const nextCompareAtPrice = `${srOnly}${formatStickyMoney(baseCompareAtPrice * quantity)}`;

        if (compareAtPrice.innerHTML !== nextCompareAtPrice) {
          compareAtPrice.innerHTML = nextCompareAtPrice;
        }

        compareAtPrice.hidden = false;
      } else if (Number.isFinite(goSubPrice) && basePrice > goSubPrice) {
        const srOnly = compareAtPrice.querySelector('.sr-only')?.outerHTML || '';
        const nextCompareAtPrice = `${srOnly}${formatStickyMoney(basePrice * quantity)}`;

        if (compareAtPrice.innerHTML !== nextCompareAtPrice) {
          compareAtPrice.innerHTML = nextCompareAtPrice;
        }

        compareAtPrice.hidden = false;
      } else {
        compareAtPrice.hidden = true;
      }

      stickyBar.removeAttribute('data-lc-sticky-price-pending');
    });
  }

  function initializeStickyPriceUpdater() {
    if (stickyPriceInitialized) return;

    stickyPriceInitialized = true;

    document.addEventListener('input', event => {
      if (event.target.matches('input[name="quantity"]')) {
        updateStickyBarPrices();
      }
    }, true);

    document.addEventListener('change', event => {
      if (event.target.matches('input[name="quantity"], input[name="id"], input, select')) {
        window.setTimeout(updateStickyBarPrices, 0);
        window.setTimeout(updateStickyBarPrices, 100);
      }
    }, true);

    const observedGoSubPrices = new WeakSet();
    const observeGoSubPrice = element => {
      if (!element || observedGoSubPrices.has(element)) return;

      observedGoSubPrices.add(element);
      goSubPriceObserver.observe(element, {
        childList: true,
        characterData: true,
        subtree: true
      });
    };
    const observeGoSubPrices = root => {
      if (!(root instanceof Element || root instanceof Document)) return;

      if (root.matches?.('.gosub-new-price-banner')) {
        observeGoSubPrice(root);
      }

      root.querySelectorAll?.('.gosub-new-price-banner').forEach(observeGoSubPrice);
    };
    const goSubPriceObserver = new MutationObserver(() => {
      window.requestAnimationFrame(updateStickyBarPrices);
    });
    const goSubMountObserver = new MutationObserver(mutations => {
      let shouldUpdate = false;

      mutations.forEach(mutation => {
        if (mutation.target.closest?.('product-sticky-bar')) return;

        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;

          observeGoSubPrices(node);
          shouldUpdate = true;
        });
      });

      if (shouldUpdate) {
        window.requestAnimationFrame(updateStickyBarPrices);
      }
    });

    observeGoSubPrices(document);

    document.addEventListener('click', event => {
      if (event.target.closest('.gosub-new-price-banner, [class*="gosub"], [id*="gosub"]')) {
        window.setTimeout(updateQuantityLinkedProductPrices, 100);
        window.setTimeout(updateStickyBarPrices, 100);
      }
    }, true);

    document.body.addEventListener('change', event => {
      if (event.target.closest('[class*="gosub"], [id*="gosub"]')) {
        window.setTimeout(updateQuantityLinkedProductPrices, 100);
        window.setTimeout(updateStickyBarPrices, 100);
      }
    }, true);

    window.addEventListener('pagehide', () => {
      savePurchaseOptionSelections();

      document.querySelectorAll('product-sticky-bar[data-lc-sticky-price]').forEach(stickyBar => {
        stickyBar.setAttribute('data-lc-sticky-price-pending', '');
      });

      document.querySelectorAll('[data-lc-product-price]').forEach(priceItem => {
        priceItem.setAttribute('data-lc-product-price-pending', '');
      });
    });

    goSubMountObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    updateStickyBarPrices();
  }

  function initializePageRestorePriceSync() {
    window.addEventListener('pageshow', event => {
      if (!beginPurchaseOptionHistoryRestore(event)) return;

      const syncRestoredPrices = () => {
        restorePurchaseOptionSelections();
        syncAllGoSubSellingPlans();
        updatePurchaseOptionProductPrices();
        updateQuantityLinkedProductPrices();
        updateStickyBarPrices();
      };

      window.requestAnimationFrame(syncRestoredPrices);
      window.setTimeout(syncRestoredPrices, 100);
    });
  }

  function initializeDescriptionYouTubeFullscreen() {
    const descriptionIframeSelector = [
      '.product-content-below-gallery__description iframe',
      '.lc-product-info__block-item[data-block-type="description"] iframe'
    ].join(', ');

    const enableFullscreen = root => {
      if (!(root instanceof Element || root instanceof Document)) return;

      const iframes = root.matches?.(descriptionIframeSelector)
        ? [root]
        : Array.from(root.querySelectorAll?.(descriptionIframeSelector) || []);

      iframes.forEach(iframe => {
        let hostname;

        try {
          hostname = new URL(iframe.src, window.location.href).hostname;
        } catch (error) {
          return;
        }

        if (!hostname.includes('youtube.com') && !hostname.includes('youtube-nocookie.com') && !hostname.includes('youtu.be')) return;
        if (iframe.hasAttribute('allowfullscreen') && iframe.allow.split(';').some(permission => permission.trim() === 'fullscreen')) return;

        const fullscreenIframe = iframe.cloneNode(true);
        const permissions = fullscreenIframe.allow
          .split(';')
          .map(permission => permission.trim())
          .filter(Boolean);

        if (!permissions.includes('fullscreen')) permissions.push('fullscreen');

        fullscreenIframe.allow = permissions.join('; ');
        fullscreenIframe.setAttribute('allowfullscreen', '');
        iframe.replaceWith(fullscreenIframe);
      });
    };

    enableFullscreen(document);

    const descriptionObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) enableFullscreen(node);
        });
      });
    });

    descriptionObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function initializeJudgeMeReviewTitleFallback() {
    const mainProductSection = document.querySelector('.shopify-section--main-product');

    if (!mainProductSection) return;

    const addFallbackTitles = root => {
      if (!(root instanceof Element || root instanceof Document)) return;

      const reviews = root.matches?.('.jdgm-rev')
        ? [root]
        : Array.from(root.querySelectorAll?.('.jdgm-rev') || []);

      reviews.forEach(review => {
        const title = review.querySelector('.jdgm-rev__title');

        if (title?.textContent.trim()) return;

        if (title) {
          title.textContent = 'タイトルなし';
          return;
        }

        const body = review.querySelector('.jdgm-rev__body');

        if (!body) return;

        const fallbackTitle = document.createElement('b');
        fallbackTitle.className = 'jdgm-rev__title';
        fallbackTitle.textContent = 'タイトルなし';
        body.before(fallbackTitle);
      });
    };

    addFallbackTitles(mainProductSection);

    const reviewObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) addFallbackTitles(node);
        });
      });
    });

    reviewObserver.observe(mainProductSection, {
      childList: true,
      subtree: true
    });
  }

  function initialize() {
    if (isInitialized) return;

    isInitialized = true;

    document.addEventListener('click', handleClick, true);
    document.addEventListener('click', handleButtonClick, true);
    document.addEventListener('submit', handleFormSubmit, true);

    document.addEventListener('input', function (e) {
      const target = e.target;

      if (target.name === 'properties[名入れ文字]') {
        handleInputChange();
      }
    }, true);

    document.addEventListener('change', function (e) {
      const target = e.target;

      if (target.name === 'properties[名入れ文字]') {
        handleInputChange();
      }
    }, true);

    observer = new MutationObserver(() => {
      updateCustomilyVisibility();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });


    document.querySelectorAll('fieldset.variant-picker__option').forEach(fieldset => {
  if (!isNamePrintFieldset(fieldset)) return;

  const state = getCurrentNamePrintState(fieldset);
  applyState(fieldset, state);
});

    updateSubmitButtonState();
  }

  function checkAndInitialize() {
    const lcOptions = document.querySelector('#lc-options');

    if (lcOptions) {
      initialize();
      return true;
    }

    return false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    beginPurchaseOptionHistoryRestore();
    initializeGoSubSellingPlanSync();
    initializeQuantityLinkedProductPrices();
    initializeStickyPriceUpdater();
    initializePageRestorePriceSync();
    initializeDescriptionYouTubeFullscreen();
    initializeJudgeMeReviewTitleFallback();

    if (checkAndInitialize()) return;

    const checkObserver = new MutationObserver(() => {
      if (checkAndInitialize()) {
        checkObserver.disconnect();
      }
    });

    checkObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(() => {
      checkObserver.disconnect();
    }, 3000);
  });
})();
